import { useState, useEffect } from "react";
import "./ShutterToggle.scss";

const DEFAULT_LABEL = "Privacy shutter";
const DEFAULT_OPTIONS = [
    { key: "on", label: "ON", sequence: "startOpenShutterAnimation" },
    { key: "off", label: "OFF", sequence: "startCloseShutterAnimation" },
];

const ShutterToggle = ({ config }) => {
    const toggleLabel = config?.label || DEFAULT_LABEL;
    const OPTIONS = config?.options && config.options.length ? config.options : DEFAULT_OPTIONS;

    const [isOn, setIsOn] = useState(false);

    useEffect(() => {
        setIsOn(false);
    }, [window.selectedConfig.currentSelectedMenu, window.selectedConfig.currentSelectedHotspot]);

    const applySequence = (optionKey) => {
        const option = OPTIONS.find((o) => o.key === optionKey);

        if (
            option &&
            window.scene &&
            typeof window.scene.applySequence === "function"
        ) {
            window.scene.applySequence(window[option.sequence]);
        }
    };

    const handleToggle = () => {
        const nextState = !isOn;
        const optionKey = nextState ? "on" : "off";

        applySequence(optionKey);
        setIsOn(nextState);
    };

    const currentOption = OPTIONS.find((o) => o.key === (isOn ? "on" : "off"));
    const displayText = currentOption ? currentOption.label : (isOn ? "ON" : "OFF");

    return (
        <div className="shutterToggle" onClick={(e) => e.stopPropagation()}>
            <div className="toggleLabel">
                {toggleLabel}
            </div>
            <div
                className={`toggleTrack ${isOn ? "on" : "off"}`}
                onClick={handleToggle}
                role="button"
                tabIndex={0}
                aria-checked={isOn}
                aria-label="Privacy shutter toggle"
                onKeyDown={(e) => e.key === "Enter" && handleToggle()}
            >
                <div className="toggleInnerPill">
                    <span className="toggleText">{displayText}</span>
                    <div className="toggleKnob"></div>
                </div>
            </div>
        </div>
    );
};

export default ShutterToggle;